import axios from "axios";

const ApiInstance = axios.create({
  baseURL: process.env.VUE_APP_API_HOST,
});

ApiInstance.interceptors.request.use(
  (config) => {
    const userToken = localStorage.getItem("access_token");

    if (config.headers && userToken) {
      config.headers["AuthorizationJWT"] = userToken;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export { ApiInstance };
